import React from 'react';
import { RoutePermittedRole } from 'constants/AppConst';
import { ROUTE_STRING } from 'constants/RouteString';
import { Box, Breadcrumbs, Typography } from '@mui/material';
import { initialValuesStepInformation } from 'pages/publishApp/helpers/initialValues';
import { useNavigate } from 'react-router-dom';
import useCreateApp from './hooks/useCreateApp';
import AppsContainer from '@tenant/core/AppsContainer';
import { ACTION_MODE_ENUM } from 'constants/AppEnums';
import Steps from './components/Steps';
import { useAuthUser } from '@tenant/utility/AuthHooks';
import AllowedAccess from '@tenant/core/AppPermission/AllowedAccess';
import { AuthorizePermission } from '@tenant/utility/constants/authorizePermission';
import { toast } from 'react-toastify';

const CreateApp = () => {
	const navigate = useNavigate();
	const { mutate, isPending, isSuccess } = useCreateApp();
	const { user } = useAuthUser();

	const handleSubmit = data => {
		mutate(data, {
			onSuccess: data => {
				toast.success('Your app has been successfully created.');

				if (data) {
					navigate(ROUTE_STRING.LIST_APP.EDIT.replace(':appId', data));
					return;
				}

				navigate(ROUTE_STRING.LIST_APP.LIST);
			}
		});
	};

	return (
		<AppsContainer
			fullView
			title={
				<Breadcrumbs aria-label="breadcrumb">
					<Typography color="text.primary">Developer</Typography>
					<Typography color="text.primary">Create App</Typography>
				</Breadcrumbs>
			}
		>
			<Box sx={{ p: 4 }}>
				<Steps
					mode={ACTION_MODE_ENUM['Create']}
					input={{
						...initialValuesStepInformation,
						AuthorName: 'Joblogic',
						AuthorEmail: user.username,
						IsPublic: false
					}}
					submit={handleSubmit}
					isPending={isPending}
					isSuccess={isSuccess}
				/>
			</Box>
		</AppsContainer>
	);
};

export const publishAppRoutes = [
	{
		permittedRole: RoutePermittedRole.User,
		path: ROUTE_STRING.CREATE_APP,
		element: (
			<AllowedAccess isPageFailed permissionIds={[AuthorizePermission.APP_CREATE]}>
				<CreateApp />
			</AllowedAccess>
		)
	}
];
